import { useContext } from 'react';
import { ApplicationContext } from 'src/contexts/ApplicationContext';

function useApplicationData() {
  const { applicationData } = useContext(ApplicationContext);

  return applicationData;
}

export default useApplicationData;
